import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";

import { withRouter, RouteComponentProps } from "react-router-dom";
import { performancePages } from "../../../../constants";

import PmoTooltip from "../../../ProductMarketingOptimization/components/common/PmoTooltip";
import CompetitorSelect from "../competitorSelect";
import BrandKPITrend from "./BrandKPITrend";
import { getBrandKPITrend } from "../../../../api/brandPerformanceApi";
import LoadingEllipsis from "../../../../components/Loading/LoadingEllipsis";
import { NoDataMsg } from "../../../../components/AppMessages";

interface Props extends RouteComponentProps {
  onHandleRadioClick: any;
  nissanCompetitor: string;
  activePage: performancePages;
  diff: number;
  maxScoreRange: number;
  granularity: string;
}

export type MetricType = "OaO" | "Innovative" | "Excitement" | "EV TOM" | "AD TOM" | "Fun to Drive";

const keyOrder = {
  "OaO": 1,
  "Innovative": 2,
  "Fun to Drive": 3,
  "Excitement": 4,
  "EV TOM": 5,
  "AD TOM": 6,
}

const BrandKPIContent = withRouter((props: Props) => {
  const { onHandleRadioClick, nissanCompetitor, activePage, diff, maxScoreRange, granularity, history } = props;
  const params = useSelector((state: RootStateOrAny) => state.parameters);

  // const metrics = ["OaO", "Innovative", "Excitement", "EV ToM", "AD ToM"];

  const {
    data: brandKPITrendData,
    isFetching: loadingBrandKPITrendData,
    refetch: refetchBrandKPITrendData,
  } = useQuery(["brandKPITrend", granularity, history.location.search], () => getBrandKPITrend({ ...params, nissan_competitor: nissanCompetitor }), {
    enabled: false,
  });
  // when the url changes, refetch the data
  useEffect(() => {
    refetchBrandKPITrendData();
  }, [history.location.search]);

  // get all the keys from the data object
  const keys: MetricType[] = brandKPITrendData?.data ? (Object.keys(brandKPITrendData?.data) as MetricType[]) : [];
  keys.sort((a, b) => {
    return keyOrder[a] - keyOrder[b]
  })

  return (
    <div className="brand-KPI-main-content">
      <div className="primary_background ">
        <div className="header" style={{ paddingTop: "1em", paddingLeft: "1em" }}>
          <div className="title_container">
            <h3>Brand KPI Trend</h3>
            <CompetitorSelect onHandleRadioClick={onHandleRadioClick} nissanCompetitor={nissanCompetitor} />
          </div>
          <div className="legenddiv"></div>
        </div>
        <div className="chart_content_container">
          {keys?.length && !loadingBrandKPITrendData ? (
            keys?.map((metric) => (
              <div key={metric} className="chart_content">
                <BrandKPITrend
                  trendTitle={metric}
                  percentageChart={true}
                  diff={diff}
                  nissanCompetitor={nissanCompetitor}
                  metric={metric}
                  maximumScoreRange={maxScoreRange}
                  data={brandKPITrendData["data"][metric as MetricType]}
                  granularity={granularity}
                  loadingBrandKPITrendData={loadingBrandKPITrendData}
                  series={brandKPITrendData?.series}
                  chartTitles={keys}
                />
              </div>
            ))
          ) : loadingBrandKPITrendData ? (
            <LoadingEllipsis isLoading={true} />
          ) : (
            <NoDataMsg message="No data available" />
          )}{" "}
        </div>
      </div>
    </div>
  );
});

export default BrandKPIContent;
